import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getSecurityApplicationMasterList_action, insertUpdateSecurityApplicationMaster_action, deleteSecurityApplicationMaster_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/security_application_master_action'
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Footer from "../../../../../common_components/Footer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



class SecurityApplicationMasterList extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            SecurityApplicationContactList: [],
            descriptionDraftList: [],
            deleteID: '',
            deleteType: '',
            isAllDisableDayShift: false,
            isAllDisableNightShift: false,
        }
        this.getSecurityApplicationMasterList = this.getSecurityApplicationMasterList.bind(this)
        this.deleteSecurityApplicationMaster = this.deleteSecurityApplicationMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.addDescriptionRow = this.addDescriptionRow.bind(this)
        this.deleteDescriptionRow = this.deleteDescriptionRow.bind(this)
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this)
        this.saveDescriptions = this.saveDescriptions.bind(this)
    }

    componentDidMount() {
        this.getSecurityApplicationMasterList()
    }

    getSecurityApplicationMasterList() {
        this.setState({ isLoading: true })
        this.props.getSecurityApplicationMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    const rawDesc = data.data[1] ? data.data[1] : []
                    const descriptionDraftList = rawDesc.map(r => ({
                        SecurityApplicationDescriptionID: r.SecurityApplicationDescriptionID,
                        Date: r.Date ? new Date(r.Date) : null,
                        Description: r.Description || '',
                        DayRateINR: r.DayRateINR != null ? r.DayRateINR : '',
                        NightRateINR: r.NightRateINR != null ? r.NightRateINR : '',
                        DayRateUSD: r.DayRateUSD != null ? r.DayRateUSD : '',
                        NightRateUSD: r.NightRateUSD != null ? r.NightRateUSD : '',
                        DisableDayShift: r.DisableDayShift || false,
                        DisableNightShift: r.DisableNightShift || false,
                        isNew: false,
                    }))
                    this.setState({
                        SecurityApplicationContactList: data.data[0] ? data.data[0] : [],
                        descriptionDraftList,
                        isLoading: false,
                        isAllDisableDayShift: descriptionDraftList.every(r => r.DisableDayShift),
                        isAllDisableNightShift: descriptionDraftList.every(r => r.DisableNightShift),
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    deleteSecurityApplicationMaster(id) {
        const { deleteType } = this.state
        this.setState({ isLoading: true })
        this.props.deleteSecurityApplicationMaster_action(deleteType == 1 ? id : '', deleteType == 2 ? id : '')
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false, deleteType: '' })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getSecurityApplicationMasterList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Handle Add (for contact/bank only now)
    handleAdd() {
        this.props.navigate('/securityApplicationMasterAU', { state: { status: 1 } })
    }

    onDelete(id, index, status) {
        this.setState({ deleteID: id, deleteType: status, isOpen: true })
    }

    addDescriptionRow() {
        const { descriptionDraftList } = this.state
        this.setState({
            descriptionDraftList: [...descriptionDraftList, {
                SecurityApplicationDescriptionID: null,
                Date: null,
                Description: '',
                DayRateINR: '',
                NightRateINR: '',
                DayRateUSD: '',
                NightRateUSD: '',
                isNew: true,
            }]
        })
    }

    deleteDescriptionRow(index) {
        const { descriptionDraftList } = this.state
        const row = descriptionDraftList[index]
        if (row.isNew) {
            // Unsaved row — just remove from list
            this.setState({ descriptionDraftList: descriptionDraftList.filter((_, i) => i !== index) })
        } else {
            // Existing row — delete via API then re-fetch
            this.setState({ isLoading: true })
            this.props.deleteSecurityApplicationMaster_action('', row.SecurityApplicationDescriptionID)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Deleted successfully")
                        this.getSecurityApplicationMasterList()
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.setState({ isLoading: false })
                })
        }
    }

    handleDescriptionChange(index, field, value) {
        const { descriptionDraftList } = this.state
        const updated = descriptionDraftList.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        )
        this.setState({
            descriptionDraftList: updated,
            isAllDisableDayShift: updated.every(r => r.DisableDayShift),
            isAllDisableNightShift: updated.every(r => r.DisableNightShift),
        })
    }

    saveDescriptions() {
        const { descriptionDraftList } = this.state
        if (descriptionDraftList.length === 0) {
            toastError("Please add at least one row")
            return
        }
        for (let i = 0; i < descriptionDraftList.length; i++) {
            const row = descriptionDraftList[i]
            if (!row.Date) { toastError(`Row ${i + 1}: Please select a date`); return }
            if (!row.DayRateINR && row.DayRateINR !== 0) { toastError(`Row ${i + 1}: Please enter Rate Per Guards (INR)`); return }
        }
        const entry = descriptionDraftList.map(row => ({
            date: moment(row.Date).format('YYYY-MM-DD'),
            Description: row.Description || null,
            DayRateINR: row.DayRateINR || null,
            NightRateINR: row.NightRateINR || null,
            DayRateUSD: row.DayRateUSD || null,
            NightRateUSD: row.NightRateUSD || null,
            DisableDayShift: row.DisableDayShift || false,
            DisableNightShift: row.DisableNightShift || false,
        }))
        this.setState({ isLoading: true })
        this.props.insertUpdateSecurityApplicationMaster_action([], entry)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Descriptions saved successfully")
                    this.getSecurityApplicationMasterList()
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    render() {
        const { isLoading, isOpen, SecurityApplicationContactList, descriptionDraftList, isAllDisableDayShift, isAllDisableNightShift } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">Security Services Master</h6>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 px-0">
                                <div className="row m-0">
                                    <div>
                                        {/* Description inline editable table */}
                                        <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                            <h3 className="card-title" style={{ fontSize: 15 }}>
                                                Security Services Description List
                                            </h3>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center" style={{ width: '50px' }}>Sr No.</th>
                                                        <th className="text-center">Date</th>
                                                        {/* <th className="text-center">Description</th> */}
                                                        <th className="text-center">Rate Per Guards (INR)</th>
                                                        {/* <th className="text-center">Night Rate (INR)</th> */}
                                                        <th className="text-center">Rate Per Guards (USD)</th>
                                                        {/* <th className="text-center">Night Rate (USD)</th> */}
                                                        <th className="text-center">Disable for Day Shift <br />
                                                            <label className="text-center" style={{ cursor: 'pointer' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isAllDisableDayShift}
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;

                                                                        this.setState((prevState) => ({
                                                                            descriptionDraftList: prevState.descriptionDraftList.map((r) => ({
                                                                                ...r,
                                                                                DisableDayShift: checked
                                                                            })),
                                                                            isAllDisableDayShift: checked
                                                                        }));
                                                                    }}
                                                                /> Select All
                                                            </label>
                                                        </th>
                                                        <th className="text-center">Disable for Night Shift<br />
                                                            <label className="text-center" style={{ cursor: 'pointer' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isAllDisableNightShift}
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;

                                                                        this.setState((prevState) => ({
                                                                            descriptionDraftList: prevState.descriptionDraftList.map((r) => ({
                                                                                ...r,
                                                                                DisableNightShift: checked
                                                                            })),
                                                                            isAllDisableNightShift: checked
                                                                        }));
                                                                    }}
                                                                /> Select All
                                                            </label>
                                                        </th>
                                                        <th className="text-center" style={{ width: '60px' }}>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {descriptionDraftList.length > 0 ? descriptionDraftList.map((row, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">
                                                                <DatePicker
                                                                    selected={row.Date}
                                                                    onChange={(date) => this.handleDescriptionChange(index, 'Date', date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    placeholderText="Select date"
                                                                    popperProps={{ strategy: "fixed" }}
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                />
                                                            </td>
                                                            {/* <td className="text-center">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={row.Description}
                                                                    onChange={(e) => this.handleDescriptionChange(index, 'Description', e.target.value)}
                                                                />
                                                            </td> */}
                                                            <td className="text-center">
                                                                <input
                                                                    type="number"
                                                                    className="form-control text-center"
                                                                    value={row.DayRateINR}
                                                                    min={0}
                                                                    onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                    onChange={(e) => this.handleDescriptionChange(index, 'DayRateINR', e.target.value)}
                                                                />
                                                            </td>
                                                            {/* <td className="text-center">
                                                                <input
                                                                    type="number"
                                                                    className="form-control text-center"
                                                                    value={row.NightRateINR}
                                                                    min={0}
                                                                    onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                    onChange={(e) => this.handleDescriptionChange(index, 'NightRateINR', e.target.value)}
                                                                />
                                                            </td> */}
                                                            <td className="text-center">
                                                                <input
                                                                    type="number"
                                                                    className="form-control text-center"
                                                                    value={row.DayRateUSD}
                                                                    min={0}
                                                                    onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                    onChange={(e) => this.handleDescriptionChange(index, 'DayRateUSD', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={row.DisableDayShift}
                                                                    onChange={(e) => this.handleDescriptionChange(index, 'DisableDayShift', e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={row.DisableNightShift}
                                                                    onChange={(e) => this.handleDescriptionChange(index, 'DisableNightShift', e.target.checked)}
                                                                />
                                                            </td>
                                                            {/* <td className="text-center">
                                                                <input
                                                                    type="number"
                                                                    className="form-control text-center"
                                                                    value={row.NightRateUSD}
                                                                    min={0}
                                                                    onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                    onChange={(e) => this.handleDescriptionChange(index, 'NightRateUSD', e.target.value)}
                                                                />
                                                            </td> */}
                                                            <td className="text-center">
                                                                <i
                                                                    className="fa fa-trash text-danger"
                                                                    style={{ cursor: 'pointer', fontSize: '16px' }}
                                                                    onClick={() => this.deleteDescriptionRow(index)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr><td className="text-center" colSpan={8}>No record found</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="d-flex justify-content-between mt-2 mb-3">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={this.addDescriptionRow}
                                            >
                                                + Add Row
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-aqua btn-sm"
                                                onClick={this.saveDescriptions}
                                            >
                                                Save Descriptions
                                            </button>
                                        </div>

                                        {/* Agency contact and bank details */}
                                        <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                            <h3 className="card-title" style={{ fontSize: 15 }}>
                                                Agency contact and bank details
                                            </h3>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center">Name</th>
                                                        <th className="text-center">Address</th>
                                                        <th className="text-center">Telephone</th>
                                                        <th className="text-center">Mobile</th>
                                                        <th className="text-center">Fax</th>
                                                        <th className="text-center">Primary Email</th>
                                                        <th className="text-center">Secondary Email</th>
                                                        <th className="text-center">BankName</th>
                                                        <th className="text-center">Beneficiary Name</th>
                                                        <th className="text-center">Beneficiary Address</th>
                                                        <th className="text-center">Account Number</th>
                                                        <th className="text-center">Swift Code</th>
                                                        <th className="text-center">IFSC Code</th>
                                                        <th className="text-center">PAN Number</th>
                                                        <th className="text-center">GST Number</th>
                                                        <th style={{ width: '60px' }} className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        SecurityApplicationContactList.length > 0 ? (SecurityApplicationContactList.map((data, i) => (
                                                            <tr key={data.SecurityApplicationContactPersonID}>
                                                                <td className="text-center">{data.Name}</td>
                                                                <td className="text-center">{data.Address}</td>
                                                                <td className="text-center">{data.Phone}</td>
                                                                <td className="text-center">{data.Mobile}</td>
                                                                <td className="text-center">{data.Fax}</td>
                                                                <td className="text-center">{data.PrimaryEmail}</td>
                                                                <td className="text-center">{data.SecondaryEmail}</td>
                                                                <td className="text-center">{data.BankName}</td>
                                                                <td className="text-center">{data.BeneficiaryName}</td>
                                                                <td className="text-center">{data.BeneficiaryAddress}</td>
                                                                <td className="text-center">{data.AccountNumber}</td>
                                                                <td className="text-center">{data.SwiftCode}</td>
                                                                <td className="text-center">{data.IFSCCode}</td>
                                                                <td className="text-center">{data.PAN}</td>
                                                                <td className="text-center">{data.GST}</td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-primary btn-sm border-0"
                                                                        onClick={() => this.props.navigate('/securityApplicationMasterAU', { state: { status: 1, editData: data } })}
                                                                    >
                                                                        <i className="fa fa-pencil action_btn_table" />
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-danger btn-sm border-0"
                                                                        onClick={(e) => this.onDelete(data.SecurityApplicationContactPersonID, i, 1)}
                                                                    >
                                                                        <i className="fa fa-trash action_btn_table" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))) : <tr><td className="text-center" colSpan={16}>No record found</td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="text-end">
                                            <button
                                                type="button"
                                                className="btn btn-aqua mt-2"
                                                onClick={() => this.handleAdd()}
                                            >
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua"
                                        onClick={(e) => this.deleteSecurityApplicationMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { getSecurityApplicationMasterList_action, insertUpdateSecurityApplicationMaster_action, deleteSecurityApplicationMaster_action })(SecurityApplicationMasterList));
